import { Trans } from "@lingui/react/macro";
import { fetchRoute, routeKeys } from "@/api/Routes";
import { useQuery } from "@tanstack/react-query";
import styles from "./Route.module.scss";
import VisitCard from "./VisitCard";
import { Heading } from "@medoma/components/Heading/Heading";
import { humanFormat } from "@medoma/models/date-and-time";
import type { IRoute } from "@medoma/models/routes";

interface IRouteComponent {
  initialRoute: IRoute & { name: string };
}

const RouteFinishedAt = ({ finishedAt }: { finishedAt: Date }) => {
  const finishedTime = humanFormat(finishedAt, { timeStyle: "short" });
  return <Trans>Rutten slutfördes klockan {finishedTime}</Trans>;
};

const Route = ({ initialRoute }: IRouteComponent) => {
  const { data: route } = useQuery({
    queryKey: routeKeys.detail(initialRoute.id),
    queryFn: () => {
      return fetchRoute(initialRoute.id);
    },
    initialData: initialRoute,
  });
  const { id, finishedAt, name, status, visits } = route;
  const ongoingVisits = visits.filter(
    ({ status }) => status === "travellingTo" || status === "ongoing",
  );
  const upcomingVisitId =
    ongoingVisits.length === 0
      ? visits.find((visit) => visit.status === "planned")?.id
      : undefined;

  return (
    <article className={styles.route}>
      <Heading level="h3">{name}</Heading>
      <ol className={styles.visitList}>
        {visits.map((visit) => {
          return (
            <VisitCard
              key={visit.id}
              isUpcomingVisit={upcomingVisitId === visit.id}
              routeId={id}
              visit={visit}
            />
          );
        })}
      </ol>
      {status === "finished" ? (
        finishedAt ? (
          <RouteFinishedAt finishedAt={finishedAt} />
        ) : (
          <Trans>Rutten slutfördes</Trans>
        )
      ) : null}
    </article>
  );
};

export default Route;
